const FALLBACK_LOCALE = 'es-MX';

const rawDefaultLocale = String(import.meta.env.VITE_DEFAULT_LOCALE || FALLBACK_LOCALE).trim();

export const ENGLISH_LOCALE = 'en';
export const DEFAULT_LOCALE = rawDefaultLocale || FALLBACK_LOCALE;

// Variantes de español que aceptamos como equivalentes (la que esté publicada en Strapi gana)
export const SPANISH_VARIANTS = ['es-MX', 'es'];

// Español "canónico" para fallback estático (cuando aún no sabemos qué tiene Strapi)
export const SPANISH_LOCALE = DEFAULT_LOCALE.toLowerCase().startsWith('en')
  ? FALLBACK_LOCALE
  : DEFAULT_LOCALE;

export const isSpanishLocale = (locale) => {
  if (!locale) return false;
  const lower = String(locale).trim().toLowerCase();
  return lower === 'es' || lower.startsWith('es-');
};

export const isEnglishLocale = (locale) => {
  if (!locale) return false;
  const lower = String(locale).trim().toLowerCase();
  return lower === ENGLISH_LOCALE || lower.startsWith('en-');
};

// NO colapsa entre variantes de español: respeta el código entrante (es vs es-MX).
// Solo normaliza inglés a 'en' y devuelve DEFAULT_LOCALE si llega vacío.
export const normalizeLocale = (locale) => {
  if (!locale) return DEFAULT_LOCALE;

  const value = String(locale).trim();
  if (!value) return DEFAULT_LOCALE;

  if (isEnglishLocale(value)) return ENGLISH_LOCALE;

  return value;
};

// Lista que se sondea contra Strapi para detectar qué locales tienen contenido publicado.
export const LOCALE_CANDIDATES = Array.from(
  new Set([...SPANISH_VARIANTS, ENGLISH_LOCALE])
);
